import { Component } from '@angular/core';

@Component({
  selector: 'app-civil-liability-insurance-page',
  standalone: true,
  imports: [],
  templateUrl: './civil-liability-insurance-page.component.html',
  styleUrls: ['./civil-liability-insurance-page.component.scss'],
})
export class CivilLiabilityInsurancePageComponent {}
